import defaultErrorHandler from "actions/global/default-error-handler";
import {
  requestActionNoPagination,
  requestActionPaymentStatus,
  requestActionTaskTypes,
  requestActionGetTripById,
  requestActionEditDuration
} from "actions/action/requests";

import {
  ACTION_LOADING,
  ACTION_ERROR,
  ACTION_GET_LIST,
  ACTION_GET_STATISTICS,
  ACTION_RESET_LIST,
  ACTION_PAYMENT_STATUS,
  ACTION_TASK_TYPES,
  ACTION_GET_TRIP_BY_ID,
  ACTION_EDIT_DURATION_BY_ID
} from "actions/action/constants";
import { requestCommonSearch } from "../common/requests";

export const setLoading = (status) => ({
  type: ACTION_LOADING,
  payload: status
});

export const actionFindAll = (page = 0, size = 20, sort = "id,asc", criteria = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("trip", page, size, sort, criteria)
    .then(response => {
      dispatch({
        type: ACTION_GET_LIST,
        payload: response
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, ACTION_ERROR));
    });
};

export const actionFindStatistics = (filters = []) => dispatch => {
  if (filters === false) {
    dispatch({
      type: ACTION_GET_STATISTICS,
      payload: []
    });
    return;
  }
  dispatch(setLoading(true));
  requestActionNoPagination(filters)
    .then(response => {
      dispatch({
        type: ACTION_GET_STATISTICS,
        payload: response.data.content
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, ACTION_ERROR));
    });
};

export const actionResetList = () => dispatch => {
  dispatch({
    type: ACTION_RESET_LIST
  });
};

export const actionPaymentStatus = () => dispatch => {
  dispatch(setLoading(true));
  requestActionPaymentStatus()
    .then(response => {
      dispatch({
        type: ACTION_PAYMENT_STATUS,
        payload: response.data.content
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, ACTION_ERROR));
    });
};

export const actionTaskTypes = () => dispatch => {
  dispatch(setLoading(true));
  requestActionTaskTypes()
    .then(response => {
      dispatch({
        type: ACTION_TASK_TYPES,
        payload: response.data.content
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, ACTION_ERROR));
    });
};

export const actionGetTripById = (bikeId, startDate, endDate) => dispatch => {
  dispatch(setLoading(true));
  requestActionGetTripById(bikeId, startDate, endDate)
    .then(response => {
      dispatch({
        type: ACTION_GET_TRIP_BY_ID,
        payload: response.data.content
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, ACTION_ERROR));
    });
};

export const actionActionSearchTrip = (page = 0, size = 10, sort = "date,DESC", criteria) => dispatch => {
  requestCommonSearch("trackings", page, size, sort, criteria)
    .then(response => {
      dispatch({
        type: ACTION_GET_TRIP_BY_ID,
        payload: response
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, ACTION_ERROR));
    });
};

export const actionResetTripById = () => dispatch => {
  dispatch({
    type: ACTION_GET_TRIP_BY_ID,
    payload: []
  });
};

export const actionEditDurationById = (id, minutes) => dispatch => {
  requestActionEditDuration(id, minutes)
    .then(() => {
      dispatch({
        type: ACTION_EDIT_DURATION_BY_ID,
        payload: true
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, ACTION_ERROR));
    });
};

export const actionEditDurationResetLoading = () => dispatch => {
  dispatch({
    type: ACTION_EDIT_DURATION_BY_ID,
    payload: false
  });
};



// WEBPACK FOOTER //
// ./src/actions/action/actions.js